import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App.js';
import { PhienHetHan } from './lib/phienHetHan.js';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1 },
  },
});

const goc = document.getElementById('root');
if (!goc) throw new Error('Không tìm thấy #root trong index.html');

createRoot(goc).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* Nối lớp làm mới phiên của `lib/api.ts` vào router + cache. */}
        <PhienHetHan />
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
